import * as Yup from 'yup';

export const AiMOdalValidationSchema = Yup.object().shape({
  promptText: Yup.string().required('Prompt is required.'),
  aiModel: Yup.object().nullable().required('Please select an AI model.'),
});

export const SmsTemplateSchema = {
  name: '',
  content: '',
  collectionId: '',
};

export const DisplayingErrorMessagesSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Name can not be more than 100 characters')
    .required('Required'),
  content: Yup.string().min(5, 'Too Short!').required('Required'),
});

export const MailTemplateSchema = {
  name: '',
  subject: '',
};

export const MailTemplateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Name can not be more than 100 characters')
    .required('Required'),
  subject: Yup.string().required('Required'),
});

export const TooltipTemplateSchema = {
  name: '',
  collectionId: '',
};

export const TooltipValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Name can not be more than 100 characters')
    .required('Required'),
});

export const AgreementTemplateSchema = {
  name: '',
};

export const AgreementTemplateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Name can not be more than 100 characters')
    .required('Required'),
  subject: Yup.string().required('Required'),
});

export const TypesenseSearchSchema = {
  name: '',
  content: '',
};

export const TypesenseSearchValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Name can not be more than 100 characters')
    .required('Required'),
});

export const SocketIoSchema = {
  name: '',
  content: '',
};

export const SocketIoValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Name can not be more than 100 characters')
    .required('Required'),
});
